import React, { useState } from "react";
import { Select, Checkbox, Radio, Typography, Divider, Input } from "antd";

const { Option } = Select;
const { Link } = Typography;

export default function MultiSelector({
  items = [],
  value = [],
  onChange,
  disabled = false,
  idKey = "id",
  labelKey = "name",
  placeholder = "Select items",
  width = 290,
}) {
  const [filter, setFilter] = useState("all"); // 'all' | 'selected'
  const [search, setSearch] = useState("");

  const allIds = items.map((item) => item[idKey]);

  // Filtro por radio ("show all"/"only selected") + por buscador (search)
  const filteredItems = (
    filter === "selected"
      ? items.filter((item) => value.includes(item[idKey]))
      : items
  ).filter((item) =>
    item[labelKey].toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Select
      mode="multiple"
      showSearch={false}
      allowClear
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{ width }}
      maxTagCount={0}
      maxTagPlaceholder={() => <span>{value.length} selected</span>}
      getPopupContainer={(trigger) =>
        trigger.closest(".ant-modal-content") ?? document.body
      }
      options={filteredItems.map((item) => ({
        label: item[labelKey],
        value: item[idKey],
      }))}
      optionRender={(option) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Checkbox checked={value.includes(option.value)} />
          <span>{option.label}</span>
        </div>
      )}
      popupRender={(menu) => (
        <div>
          {/* Buscador */}
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Search items"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
              allowClear
            />
          </div>

          {menu}

          <Divider style={{ margin: "8px 0" }} />

          <div style={{ padding: "0 8px 8px" }}>
            <Radio.Group
              value={filter}
              size="small"
              onChange={(e) => setFilter(e.target.value)}
              style={{ marginBottom: 6 }}
            >
              <Radio value="all">Show all</Radio>
              <Radio value="selected" disabled={value.length === 0}>
                Only selected
              </Radio>
            </Radio.Group>

            <div style={{ marginTop: 6 }}>
              <Link
                disabled={disabled || value.length === allIds.length}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onChange(allIds)}
                style={{ marginRight: 12 }}
              >
                Select all
              </Link>

              <Link
                disabled={disabled || value.length === 0}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onChange([])}
              >
                Deselect all
              </Link>
            </div>

            {value.length > 0 && (
              <div
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  color: "#0075C9",
                  marginTop: 4,
                }}
              >
                {value.length} selected
              </div>
            )}
          </div>
        </div>
      )}
    />
  );
}
